<template>
	<div id="TeamOrders" class="teamOrders">
        <vue-snotify></vue-snotify>
        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromOrders" @change="getAllOrdersByUserLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToOrders" @change="getAllOrdersByUserLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchOrders"
					v-model="searchOrders"
					v-on:keyup.enter="getAllOrdersByUserLocal(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllOrdersByUserLocal(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nuevo Pedido" @click="showOrderModalComponentLocal">
					<i class="fas fa-plus"></i>
				</button>
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1 margin-right5" title="Buscar ubicación producto">
					<i class="fas fa-search-location" data-toggle="modal" data-target="#searchProductLocationModalComponent"></i>
				</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsOrder" @change="changeQRowsOrder">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>

        <div class="card" style="margin-bottom: 5px; font-weight: bold;" id="id0">
            <div class="card-body" style="padding-top: 5px; padding-bottom: 5px; ">
                <div class="row">
                    <div class="col-md-1 text-center">
                        ID
                    </div>
                    <div class="col-md-3 text-center">
                        Nombre
                    </div>
                    <div class="col-md-3 text-center">
                        Enviado a
                    </div>
                    <div class="col-md-2 text-center">
                        Fecha
                    </div>
                    <div class="col-md-1 text-center">
                        Monto
                    </div>
                    <div class="col-md-2 text-center">
                        Estado
                    </div>
                </div>
            </div>
        </div>
        <div class="card" style="margin-bottom: 5px" :id="'id' + (index + 1)" v-for="(item, index) in listOrders" :key="index" :class="(open != 0) ? 'text-muted' : ''">
            <div class="card-body" :class="(index + 1 == open) ? 'border border-dark rounded' : '' " style="padding-top: 5px; padding-bottom: 5px;">
                <div class="row" v-if="(index + 1 != open)">
                    <div class="col-md-1 text-center">
                        {{ item.id }}
                    </div>
                    <div class="col-md-3 text-center">
                        {{ item.client }}
                    </div>
                    <div class="col-md-3 text-center">
                        {{ item.sendto[0].sendto }}
                    </div>
                    <div class="col-md-2 text-center">
                        {{ item.created_at }}
                    </div>
                    <div class="col-md-1 text-right">
                        ${{ methodFormatNumber(item.total) }}
                    </div>
                    <div class="col-md-2 text-center" style="padding-right:5px">
                        <span class="badge" :class="'badge-' + item.color">{{ item.status }}</span>
                        <a :href="'#id' + index" class="fas fa-plus float-right pointer" style="margin-top:4px;" @click="open = (index + 1)" :title="index"></a>
                    </div>
                </div>
                <div v-else style="margin-right:-10px; margin-top:10px">
                    <div>
                        <label>Fecha de creación:</label> {{ item.created_at }}
                        <i class="fas fa-minus float-right pointer" style="margin-top:-6px; margin-left:10px;" @click="open = 0"></i>
                        <span class="float-right"><label>Estado:</label> <span class="badge" :class="'badge-' + item.color">{{ item.status }}</span></span>
                    </div>
                    <div class="row">
                        <div class="col-md-8">
                            <div class="border rounded" style="padding:10px; margin-bottom:3px">
                                <div class="row">
                                    <div class="col-md-7">
                                        <p><label>Cargado a:</label> {{ item.client }}</p>
                                        <p><label>Enviar a:</label> {{ item.sendto[0].sendto }}</p>
                                        <p><label>RUT:</label> {{ item.sendto[0].number_document }}</p>
                                    </div>
                                    <div class="col-md-5">
                                        <p><label>Nº de Pedido:</label> {{ item.id }}</p>
                                        <p><label>Telefono:</label> {{ item.sendto[0].phone }}</p>
                                        <p><label>Email:</label> {{ item.sendto[0].email }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <p>
                                            <label>Dirección:</label> {{ item.sendto[0].street }} - {{ item.sendto[0].comuna }}
                                        </p>
                                    </div>
                                </div>

                            </div>
                            <table class="table table-sm table-12">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-center">Articulo</th>
                                        <th class="text-center">Cantidad</th>
                                        <th class="text-center">Precio</th>
                                        <th class="text-center">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(it, ind) in item.order_products" :key="ind">
                                        <td class="text-center">{{ ind + 1 }}</td>
                                        <td>{{ it.product }}</td>
                                        <td class="text-center">{{ methodFormatNumber(it.quantity) }}</td>
                                        <td class="text-right">{{ methodFormatNumber(it.price) }}</td>
                                        <td class="text-right">{{ methodFormatNumber(it.price * it.quantity) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="item.tithe != null">
                                        <td colspan="4" class="text-right"><b>Sub Total:</b></td>
                                        <td class="text-right">{{ methodFormatNumber(item.total) }}</td>
                                    </tr>
                                    <tr v-if="item.tithe != null">
                                        <td colspan="4" class="text-right"><b>Diezmo:</b></td>
                                        <td class="text-right">{{ methodFormatNumber(item.tithe) }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4" class="text-right"><b>TOTAL:</b></td>
                                        <td class="text-right" v-if="item.tithe != null"><b>{{ methodFormatNumber(totalOrdersLocal(item.total, item.tithe)) }}</b></td>
                                        <td class="text-right" v-else><b>{{ methodFormatNumber(item.total) }}</b></td>
                                    </tr>
                                </tfoot>
                            </table>
                            <hr>
                            <div>
                                <table class="table table-sm table-12">
                                    <thead>
                                        <tr>
                                            <th class="text-center">#</th>
                                            <th class="text-center">Forma de Pago</th>
                                            <th class="text-center">Monto</th>
                                            <th class="text-center">Banco</th>
                                            <th class="text-center">Codigo</th>
                                            <th class="text-center">Descripción</th>
                                            <th class="text-right" style="width: 40px;"><i class="fas fa-plus-square text-primary pointer" v-show="plusPayment  && (auth.role_id != 9 && auth.role_id != 10) " @click="plusPayment = !plusPayment"></i></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(it, ind) in item.order_payments" :key="ind">
                                            <td class="text-center">{{ ind + 1 }}</td>
                                            <td class="text-center">{{ it.payment }}</td>
                                            <td class="text-right">{{ methodFormatNumber(it.amount) }}</td>
                                            <td class="text-center">{{ it.bank }}</td>
                                            <td class="text-center">{{ it.code }}</td>
                                            <td>{{ it.description }}</td>
                                            <td class="text-right pointer">
                                                <i class="fas fa-minus-circle text-danger" @click="deleteOrderPaymentLocal(it)"></i>
                                            </td>
                                        </tr>
                                        <tr v-show="!plusPayment">
                                            <td>0</td>
                                            <td>
                                                <select v-model="dataPayment.payment_id">
                                                    <option v-for="(it, ind) in listTypePayments" :key="ind" :value="it.id">{{ it.name }}</option>
                                                </select>
                                            </td>
                                            <td class="text-right"><input type="number" class="text-right" v-model="dataPayment.amount" style="width: 100px;"/></td>
                                            <td>
                                                <select v-model="dataPayment.bank_id">
                                                    <option v-for="(it, ind) in listBanks" :key="ind" :value="it.id">{{ it.name }}</option>
                                                </select>
                                            </td>
                                            <td><input type="text" class="text-right" v-model="dataPayment.code" style="width: 100px;"/></td>
                                            <td><input type="text" class="text-right" v-model="dataPayment.description"  style="width: 150px;"/></td>
                                            <td class="text-right">
                                                <i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveOrderPaymentLocal(item.id, dataPayment)"></i>
                                                <i class="fas fa-minus-circle pointer text-danger" @click="plusPayment = !plusPayment"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="border rounded border-info" style="padding:10px; margin-bottom:3px">
								<div class="post" v-for="(it, ind) in item.order_observations" :key="ind" style="border: none">
									<div class="user-block" style="border-bottom: 1px solid #ccc">
										<img class="img-circle img-bordered-sm" :src="'/img/perfil/' + it.img" alt="user image">
                                        <span class="description float-right">{{ it.created_at }}</span>
										<span class="username">
											<a href="#" style="font-size: 12px;">{{ it.user }}</a>
                                            <span class="float-right btn-tool pointer" v-if="showDeleteOrderObservation(it)" @click="deleteOrderObservationLocal(it)"><i class="fas fa-times"></i></span>
										</span>
                                        <i href="#" style="font-size: 12px; margin-left:15px">{{ it.observation }}</i>
									</div>
								</div>
								<!-- /.post -->
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control form-control-sm" placeholder="Ingrese comentario" aria-label="Ingrese comentario" aria-describedby="basic-addon2" v-model="observation" @keyup.enter="saveOrderObservationLocal(item)">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary btn-sm" type="button" @click="saveOrderObservationLocal(item)" :disabled="observation.length < 3">Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                       		<div class="tab-pane" id="timeline">
								<!-- The timeline -->
								<div class="timeline timeline-inverse">
									<!-- /.timeline-label -->
									<!-- timeline item -->
									<div>
										<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[0].value != '----/--/-- --:--'"></i>
                                        <i class="far fa-clock bg-gray" v-else></i>
										<div class="timeline-item">
											<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[0].value }}</span>
											<h3 class="timeline-header"><a>Creado</a></h3>
										</div>
									</div>
									<!-- END timeline item -->
									<!-- timeline item -->
									<div>
										<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[1].value != '----/--/-- --:--'"></i>
                                        <i class="far fa-clock bg-gray" v-else></i>
										<div class="timeline-item">
											<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[1].value }}</span>
											<h3 class="timeline-header">
                                                <a v-if="existsTrackingsOrder[1].value != '----/--/-- --:--'">Confirmado</a>
                                                <a href="#" class="text-muted" v-else @click="showDataToConfirmModal(item.id)" >Confirmar</a>
                                            </h3>
										</div>
									</div>
									<!-- END timeline item -->
									<!-- timeline item -->
									<div>
										<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[3].value != '----/--/-- --:--'"></i>
                                        <i class="far fa-clock bg-gray" v-else></i>
										<div class="timeline-item">
											<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[3].value }}</span>
											<h3 class="timeline-header">
                                                <a href="#" :class="(existsTrackingsOrder[3].value == '----/--/-- --:--') ? 'text-muted' : ''">Atendido</a>
                                            </h3>
										</div>
									</div>
									<div>
										<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[4].value != '----/--/-- --:--'"></i>
                                        <i class="far fa-clock bg-gray" v-else></i>
										<div class="timeline-item">
											<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[4].value }}</span>
											<h3 class="timeline-header">
                                                <a href="#" :class="(existsTrackingsOrder[4].value == '----/--/-- --:--') ? 'text-muted' : ''">Empacado</a>
                                            </h3>
                                            <div class="timeline-body text-right" v-if="item.shipping.length == 1 && existsTrackingsOrder[4].value != '----/--/-- --:--'">
                                                Bultos: <span class="badge badge-secondary">{{ item.shipping[0].packages }}</span> 
                                                Peso: <span class="badge badge-dark">{{ item.shipping[0].weight }}</span>
											</div>
										</div>
									</div>
									<div>
										<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[5].value != '----/--/-- --:--'"></i>
                                        <i class="far fa-clock bg-gray" v-else></i>
										<div class="timeline-item">
											<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[5].value }}</span>
											<h3 class="timeline-header">
                                                <a href="#" :class="(existsTrackingsOrder[5].value == '----/--/-- --:--') ? 'text-muted' : ''">Despachado</a>
                                            </h3>
                                            <div class="timeline-body text-right" v-if="item.shipping.length == 1 && existsTrackingsOrder[5].value != '----/--/-- --:--'">
                                                <span class="badge" :class="'badge-'+getColorTransport(item.shipping[0].transport_id)">{{ item.shipping[0].transport }} 
                                                    <span v-if="item.shipping[0].freight_order != ''" @dblclick="getInfoShippingCourrier(item.shipping[0])" class="pointer">OF {{ item.shipping[0].freight_order }}</span>
                                                </span>
											</div>
										</div>
									</div>
									<div>
										<i class="fas fa-check bg-success" v-if="existsTrackingsOrder[6].value != '----/--/-- --:--'"></i>
                                        <i class="far fa-clock bg-gray" v-else></i>
										<div class="timeline-item">
											<span class="time"><i class="far fa-clock"></i> {{ existsTrackingsOrder[6].value }}</span>
											<h3 class="timeline-header">
                                                <a href="#" :class="(existsTrackingsOrder[6].value == '----/--/-- --:--') ? 'text-muted' : ''">Entregado</a>
                                            </h3>
										</div>
									</div>
								</div>
							</div>
                            <div class="text-right align-bottom">
                                <button class="btn btn-secondary btn-sm float-right align-bottom" style="margin: 10px" @click="open = 0">Cerrar</button>
                                <button class="btn btn-danger btn-sm float-right align-bottom" style="margin: 10px" @click="deleteOrderLocal(item)" v-if="existsTrackingsOrder[1].value == '----/--/-- --:--'">Eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pagination :pagination="paginationOrders" @getAllList="getAllOrdersByUser"></pagination>

        <div class="modal fade" id="dataToConfirmModal"  data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Datos para Confirmar - Orden Nº {{ objectOrder.id }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="inputSendToOrderModule" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Enviar a:</label>
                                    <div class="col-sm-8">
                                         <input type="text" class="form-control form-control-sm" v-model="objectOrder.sendto[0].sendto" id="inputSendToOrderModule"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="inputPhoneModule" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Telefono:</label>
                                    <div class="col-sm-7">
                                        <input type="text" class="form-control form-control-sm" v-model="objectOrder.sendto[0].phone" id="inputPhoneModule"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="inputSendToOrderModule" class="col-sm-4 col-form-label text-right" style="font-weight: normal">RUT:</label>
                                    <div class="col-sm-8">
                                         <input type="text" class="form-control form-control-sm" v-model="objectOrder.sendto[0].number_document" id="inputSendToOrderModule"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="inputPhoneModule" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Email:</label>
                                    <div class="col-sm-7">
                                        <input type="text" class="form-control form-control-sm" v-model="objectOrder.sendto[0].email" id="inputPhoneModule"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="inputAddressModule" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Dirección:</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control form-control-sm" v-model="objectOrder.sendto[0].street" id="inputAddressModule"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="inputComunaModule" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Comuna:</label>
                                    <div class="col-sm-7">
                                        <select class="form-control form-control-sm" id="inputComunaModule" v-model="objectOrder.sendto[0].comuna_id">
                                            <option v-for="(it, ind) in listComunas" :key="ind" :value="it.id">{{ it.name }} ({{ it.region }})</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center border-top">Transporte</div>
                        <div class="col-sm-12 border rounded text-center" style="padding-top:5px; ">
                            <div v-for="(item, index) in listTransports" :key="index" class="form-check form-check-inline" :title="item.name" style="font-size: 12px">
                                <input class="form-check-input" type="radio" name="inlineRadioOptionsTransports" :id="'inlineRadioTransports' + index" :value="item.id" v-model="dataConfirm.transportId">
                                <label class="form-check-label" :for="'inlineRadioTransports' + index"><span class="badge" :class="'badge-' + item.color">{{ item.name }}</span></label>
                                
                            </div>
                        </div>
                        <div class="text-center border-top" style="margin-top: 5px">Cobro</div>
                        <div class="col-sm-12 border rounded text-center" style="padding-top:5px; ">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptionsCtaCte" id="inlineRadioCtaCte" value="0" v-model="dataConfirm.ctacteId">
                                <label class="form-check-label" for="inlineRadioCobros'">Por Pagar</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptionsCtaCte" id="inlineRadioCtaCte" value="1" v-model="dataConfirm.ctacteId">
                                <label class="form-check-label" for="inlineRadioCobros'">Cta Cte</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <b class="form-check-label" for="inlineRadioCobros'">$ {{ methodFormatNumber(objectOrder.total) }}</b>
                            </div>
                        </div>
                        <div class="text-center border-top" style="margin-top: 5px">Tipo de Documento Electronico</div>
                        <div class="col-sm-12 border rounded text-center" style="padding-top:5px; ">
                            <div class="form-check form-check-inline border-right" style="padding-right: 15px">
                                <input class="form-check-input" type="radio" name="inlineRadioOptionsCobros" id="inlineRadioCobrosSD" value="0" v-model="dataConfirm.typeLegalDocumentId">
                                <label class="form-check-label" for="inlineRadioCobrosSD'">Sin Documento</label>
                            </div>
                            <div class="form-check form-check-inline border-right" style="padding-right: 15px">
                                <input class="form-check-input" type="radio" name="inlineRadioOptionsCobros" id="inlineRadioCobrosBOL" value="39" v-model="dataConfirm.typeLegalDocumentId">
                                <label class="form-check-label" for="inlineRadioCobrosBOL'">Boleta</label>
                            </div>
                            <div class="form-check form-check-inline border-right" style="padding-right: 15px">
                                <input class="form-check-input" type="radio" name="inlineRadioOptionsCobros" id="inlineRadioCobrosFAC" value="33" v-model="dataConfirm.typeLegalDocumentId">
                                <label class="form-check-label" for="inlineRadioCobrosFAC'">Factura</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" name="inlineRadioOptionsCobros" id="inlineRadioCobros" value="52" v-model="dataConfirm.typeLegalDocument52">
                                <label class="form-check-label" for="inlineRadioCobros'">Guia de despacho</label>
                            </div>
                        </div>
                        <div class="text-center border-top" style="margin-top: 5px">Forma de Pago</div>
                        <div class="col-sm-12 border rounded text-center" style="padding-top:5px; ">
                            <table class="table table-sm table-12">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-center">Forma de Pago</th>
                                        <th class="text-center">Monto</th>
                                        <th class="text-center">Banco</th>
                                        <th class="text-center">Codigo</th>
                                        <th class="text-center">Descripción</th>
                                        <th class="text-right"><i class="fas fa-plus-square text-primary pointer" v-show="plusPayment && (auth.role_id != 9 && auth.role_id != 10) " @click="plusPayment = !plusPayment" ></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(it, ind) in objectOrder.order_payments" :key="ind">
                                        <td class="text-center">{{ ind + 1 }}</td>
                                        <td class="text-center">{{ it.payment }}</td>
                                        <td class="text-right">{{ methodFormatNumber(it.amount) }}</td>
                                        <td class="text-center">{{ it.bank }}</td>
                                        <td class="text-center">{{ it.code }}</td>
                                        <td>{{ it.description }}</td>
                                        <td class="text-right pointer">
                                            <i class="fas fa-minus-circle text-danger" @click="deleteOrderPaymentLocal(it)"></i>
                                        </td>
                                    </tr>
                                    <tr v-show="!plusPayment">
                                        <td>0</td>
                                        <td>
                                            <select v-model="dataPayment.payment_id">
                                                <option v-for="(it, ind) in listTypePayments" :key="ind" :value="it.id">{{ it.name }}</option>
                                            </select>
                                        </td>
                                        <td><input type="number" class="text-right" v-model="dataPayment.amount"/></td>
                                        <td>
                                            <select v-model="dataPayment.bank_id">
                                                <option v-for="(it, ind) in listBanks" :key="ind" :value="it.id">{{ it.name }}</option>
                                            </select>
                                        </td>
                                        <td><input type="text" class="text-right" v-model="dataPayment.code"/></td>
                                        <td><input type="text" class="text-right" v-model="dataPayment.description"/></td>
                                        <td class="text-right">
                                            <i class="far fa-save text-info pointer margin-right5" title="Guardar" @click="saveOrderPaymentLocal(objectOrder.id, dataPayment)"></i>
                                            <i class="fas fa-minus-circle pointer text-danger" @click="plusPayment = !plusPayment"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="text-center border-top" style="margin-top: 5px">Vinculaciones con Genesys</div>
                        <div class="col-sm-12 border rounded text-center" style="padding-top:5px; ">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group row">
                                        <label for="inputNrocomple" class="col-sm-6 col-form-label text-right" style="font-weight: normal; font-size: 12px">Orden de Pedido:</label>
                                        <div class="col-sm-6">
                                            <input type="number" class="form-control-sm" id="inputNrocomple" placeholder="" ref="inputNrocomple" v-model="nrocomp" v-on:keyup.enter="getMovimientoLocal(tipocompcod, nrocomp)">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group row">
                                        <div class="col-sm-12">
                                            <small id="emailHelp" class="form-text text-muted">{{ fecmov }} - {{ succod }} | {{ codbareti }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" :disabled="disableBtnContinueDataToConfirmModal" @click="btnContinueDataToConfirmModal">Continuar...</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="btnCloseDataToConfirmModal" ref="btnCloseDataToConfirmModal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#dataToConfirmModal" ref="btnDataToConfirmModal" v-show="1 == 2">Modal de Confirmación de pedido</button>

		<order-modal-component ref="orderModalComponent"
            :item="objectOrder"
            :listComunas="listComunas"
            @saveOrderComponent="saveOrderLocal">
        </order-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#orderModalComponent" ref="btnShowOrderModalComponent" v-show="1 == 2">Nuevo Pedido</button>

        <legal-document-modal-component ref="legalDocumentModalComponent"
            :urlSearch="urlSearch"
            typeLegalDocumentsId="52"
            @postSaveLegalDocumentAction="postSaveLegalDocumentAction">
        </legal-document-modal-component>

		<starken-modal-component ref="starkenModalComponent" :item="itemSelectedStarken"></starken-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#starkenModalComponent" ref="btnShowStarkenModalComponent" v-show="1 == 0"></button>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import order from '@/mixins/orders'
import shippingRequest from '@/mixins/shippingsRequest'
import comuna from '@/mixins/generals/comuna.js'
import transport from '@/mixins/transports'
import typePayment from '@/mixins/generals/typePayment.js'
import genesys from '@/mixins/genesys'
import movimiento from '@/mixins/genesys/movimiento.js'
import legalDocument from '@/mixins/legalDocuments'
import shipping from '@/mixins/shippings'
import starken from "@/mixins/starken/"

import Pagination from '@/components/Pagination.vue'
import OrderModalComponent from '@/components/OrderModalComponent.vue'
import LegalDocumentModalComponent from '@/components/LegalDocumentModalComponent.vue'
import StarkenModalComponent from '@/components/StarkenModalComponent.vue'

export default {
	name: 'TeamOrders',
	mixins: [axiosAction, errors, mixin, order, shippingRequest, comuna, transport, typePayment, genesys, movimiento, legalDocument, shipping, starken],
	data() {
		return {
            open: -1,
            urlSearch: '',
            trackingsOrder: [
                { id: 1, value: '----/--/-- --:--', user: '' },
                { id: 2, value: '----/--/-- --:--', user: '' },
                { id: 3, value: '----/--/-- --:--', user: '' },
                { id: 4, value: '----/--/-- --:--', user: '' },
                { id: 5, value: '----/--/-- --:--', user: '' },
                { id: 6, value: '----/--/-- --:--', user: '' },
                { id: 7, value: '----/--/-- --:--', user: '' },
                { id: 8, value: '----/--/-- --:--', user: '' },
            ],
            dataConfirm: {
                transportId: 0,
                ctacteId: 0,
                typeLegalDocumentId: 0,
                typeLegalDocument52: 1
            },
            valueCtacte: 30000,
            dataPayment: {
                payment_id: 0,
                amount: 0,
                bank_id: 0,
                code: '',
                description: ''
            },
            fecmov: '',
            succod: '',
            codbareti: '',
            plusPayment: true,
            tipocompcod: 20,
            nrocomp: ''
		}
	},
	computed: {
        existsTrackingsOrder() {
            if(this.open > 0) {
                let length = this.trackingsOrder.length
                for(let i=0;i<length;i++) {
                    let index = this.listOrders[this.open -1].order_tracking_order.map((el) => parseInt(el.trackings_order_id)).indexOf(parseInt(this.trackingsOrder[i].id))
                    if(index > -1) {
                        this.trackingsOrder[i].value = this.listOrders[this.open -1].order_tracking_order[index].created
                        this.trackingsOrder[i].user = this.listOrders[this.open -1].order_tracking_order[index].user
                    } else {
                        this.trackingsOrder[i].value = '----/--/-- --:--'
                        this.trackingsOrder[i].user = ''
                    }
                }
            }
            return this.trackingsOrder
        },
        listBanks() {
            let listBanks = []
            this.dataPayment.bank_id = ''
            let index = this.listTypePayments.map((el) => parseInt(el.id)).indexOf(parseInt(this.dataPayment.payment_id))
            if(index > -1)
                listBanks = this.listTypePayments[index].listBanks
            return listBanks
        },
        dataPaymentOK() {
            if(this.dataPayment.amount < 1 || this.dataPayment.payment_id < 1)
                return false
            return true
        },
        disableBtnContinueDataToConfirmModal() {
            if(this.objectOrder.sendto[0].sendto.trim().length < 3)
                return true
            if(this.objectOrder.sendto[0].phone.trim().length < 3)
                return true
            if(this.objectOrder.sendto[0].street.trim().length < 5)
                return true
            if(this.objectOrder.sendto[0].comuna_id == 0)
                return true
            if(this.dataConfirm.transportId == 0)
                return true
            return false
        },
	},
	methods: {
        showDeleteOrderObservation(item) {
            return this.auth.id == item.user_id
        },
        changeQRowsOrderLocal() {
            this.getAllOrders()
        },
        btnCloseDataToConfirmModal() {
            this.fecmov = ''
            this.succod = ''
            this.codbareti = ''
            this.nrocomp = ''
            this.dataConfirm.transportId = 0
            this.dataConfirm.ctacteId = 0
            this.dataConfirm.typeLegalDocumentId = 0
            this.dataConfirm.typeLegalDocument52 = 0
            this.plusPayment = true
            this.clearObjectOrder()
        },
        btnContinueDataToConfirmModal() {
            if(this.dataConfirm.typeLegalDocument52 != 0) {
                this.showLegalDocumentModalComponentLocal(this.objectOrder, 52)
            } else {
                this.saveShippingRequestLocal()
            }
        },
        deleteOrderLocal(item) {
			if(confirm('Esta a punto de borrar el pedido de "' + item.client + ' (' + item.id + ')"\n¿Quiere continuar?')) {
				this.deleteOrder(item.id)
			}
        },
        deleteOrderObservationLocal(it) {
            this.deleteOrderObservation(it.order_id, it.id)
        },
        deleteOrderPaymentLocal(it) {
            console.log('que pasa', it)
            this.deleteOrderPayment(it.order_id, it.id)
        },
        deleteOrderResultLocal(response) {
            this.open = 0
        },
		initModuleLocal() {
            if(this.auth.role_id == 9)
                this.setSubTitleModule('Colportaje')
            this.setOrderInit()
            this.getAllComunas()
            this.getAllTransports()
            this.setListeningOrder()
            this.getAllOrdersByUser()
            this.getAllTypePayments()
            this.clearObjectShippingRequest()
		},
        getAllComunasResultLocal(response) {},
        getAllOrdersByUserLocal(page) {
            this.open = 0
            this.getAllOrdersByUser(page)
        },
        getAllOrdersResultLocal(response) {},
        getAllTypePaymentsResultLocal() {},
        getMovimientoLocal(tipocompcod, nrocomp) {
			this.getMovimiento(tipocompcod, nrocomp)
		},
        getMovimientoResultLocal(response) {
            if(response.data.data.cabmov.fecmov != '' && response.data.data.cabmov.succod != '') {
                this.fecmov = response.data.data.cabmov.fecmov
                this.succod = response.data.data.cabmov.succod
                this.codbareti = response.data.data.cabmov.codbareti
            } else {
                this.$snotify.warning('Sin resultados ', 'No encontrado')
            }
		},
		getShippingLocal(id){
			this.clearObjectShipping()
			this.getShipping(id)
		},
		getShippingResultLocal(response){
			if(response.data.success) {
				this.$refs.btnShowShippingModalComponent.click()
			}
		},
        postSaveLegalDocumentAction(data) {
            this.saveOrderLegalDocument(data.origenId, data.id)
            setTimeout(() => { this.$refs.legalDocumentModalComponent.$refs.btnCloseLegalDocumentModalComponent.click() }, 100)
        },
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'addOrderTrackingsOrderResult': this.addOrderTrackingsOrderResult(response); break;
                case 'deleteOrderResult': this.deleteOrderResult(response); break;
                case 'deleteOrderObservationResult': this.deleteOrderObservationResult(response); break;
                case 'deleteOrderPaymentResult': this.deleteOrderPaymentResult(response); break;
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
				case 'getAllComunasResult': this.getAllComunasResult(response); break;
				case 'getAllOrdersByUserResult': this.getAllOrdersByUserResult(response); break;
				case 'getAllTypePaymentsResult': this.getAllTypePaymentsResult(response); break;
			    case 'getMovimientoResult': this.getMovimientoResult(response); break;
			    case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
			    case 'saveShippingRequestResult': this.saveShippingRequestResult(response); break;
			    case 'resultSaveShippingRequestPUT': this.resultSaveShippingRequestPOST(responseLocal, response); break;
				case 'saveOrderResult': this.saveOrderResult(response); break;
				case 'saveOrderObservationResult': this.saveOrderObservationResult(response); break;
				case 'saveOrderLegalDocumentResult': this.saveOrderLegalDocumentResult(response); break;
				case 'saveOrderShippingRequestResult': this.saveOrderShippingRequestResult(response); break;
				case 'saveOrderPaymentResult': this.saveOrderPaymentResult(response); break;
				case 'sendToRegulatoryEntityResult': this.sendToRegulatoryEntityResult(response); break;
				case 'showOrderResult': this.showOrderResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
        saveShippingRequestResultLocal(response) {
            if(this.confirmResponse(response)) {
                this.saveOrderShippingRequest(this.objectOrder.id, response.data.data.id)
            }
        },
        saveShippingRequestLocal() {
            this.objectShippingRequest.shipping_request_recipient_data[0].sendto = this.objectOrder.sendto[0].sendto
            this.objectShippingRequest.shipping_request_recipient_data[0].address = this.objectOrder.sendto[0].street
            this.objectShippingRequest.shipping_request_recipient_data[0].comuna = this.objectOrder.sendto[0].comuna
            this.objectShippingRequest.shipping_request_recipient_data[0].phone = this.objectOrder.sendto[0].phone
            this.objectShippingRequest.shipping_request_recipient_data[0].number_document = this.objectOrder.sendto[0].number_document
            this.objectShippingRequest.shipping_request_recipient_data[0].email = this.objectOrder.sendto[0].email
            this.objectShippingRequest.shipping_request_recipient_data[0].paid_shipping = this.dataConfirm.ctacteId
            this.objectShippingRequest.shipping_request_recipient_data[0].transport_id = this.dataConfirm.transportId
            this.objectShippingRequest.shipping_request_recipient_data[0].transport = this.getNameTransport(this.dataConfirm.transportId)
            this.objectShippingRequest.total_price = this.objectOrder.total
            if(this.fecmov!= '') {
                this.objectShippingRequest.shipping_request_genesys_cabmov = []
                this.setCabmovs(this.tipocompcod, this.fecmov, this.succod, this.codbareti, this.nrocomp)
            }
            this.saveShippingRequest()
        },
        saveOrderLegalDocumentResultLocal(response) {
            this.sendToRegulatoryEntity(response.data.data.legal_document_id)
        },
        saveOrderLocal(item){
            this.saveOrder(item)
        },
        saveOrderObservationLocal(item) {
            if(this.observation.length > 2) {
                this.saveOrderObservation(item.id)
            }
        },
        saveOrderPaymentLocal(id, dataPayment) {
            if(this.dataPaymentOK) {
                this.saveOrderPayment(id, dataPayment)
            } else {
                this.$snotify.warning('Tiene que completar todos los datos ', 'Falta Datos')
            }
        },
        saveOrderPaymentResultLocal(response) {},
        saveOrderResultLocal(response){
            this.$refs.orderModalComponent.$refs.btnCloseOrderModalComponent.click()
            this.clearObjectOrder()
            this.open = 1
        },
        saveOrderShippingRequestResultLocal(response) {
            this.addOrderTrackingsOrder(this.objectOrder.id, 2, 'Documento Electronico')
            this.$refs.btnCloseDataToConfirmModal.click()
        },
        sendToRegulatoryEntityResultLocal(response) {
            this.objectShippingRequest.commentary = response.data.data.type_legal_document.substring(0,1) + response.data.data.legal_document_number
            this.saveShippingRequestLocal()
        },
		searchOFStarkenResultLocal(response) {
			if(this.listOfStarken.length == 1) {
				this.itemSelectedStarken = this.listOfStarken[0]
				setTimeout(()=>{this.$refs.btnShowStarkenModalComponent.click()}, 10)
			}
		},
        showDataToConfirmModal(id) {
            if(this.auth.role_id != 9 && this.auth.role_id != 10){
                this.showOrder(id)
            } else {
                console.log('no tiene permiso para esto')
            }
        },
        showOrderResultLocal(response) {
            this.btnCloseDataToConfirmModal()
            this.setObjectOrder(response.data.data)
            console.log(this.objectOrder)
            this.dataConfirm.ctacteId = (this.objectOrder.total < this.valueCtacte) ? 0 : 1
            this.$refs.btnDataToConfirmModal.click()
        },
        showLegalDocumentModalComponentLocal(item) {
            this.urlSearch = this.apiBackend + 'order/' + item.id + '/legalDocument'
            setTimeout(() => { this.$refs.legalDocumentModalComponent.$refs.btnShowLegalDocumentModalComponent.click() }, 100)
        },
        showOrderModalComponentLocal() {
            this.clearObjectOrder()
            this.$refs.orderModalComponent.$refs.spanClearListPriceListsClient.click()
            setTimeout(() => { this.$refs.btnShowOrderModalComponent.click() }, 500)
        },
        totalOrdersLocal(total, tithe) {
            return parseInt(Math.round(parseFloat(total) + parseFloat(tithe)))
        }
	},
	components: {
        'pagination': Pagination,
		'order-modal-component': OrderModalComponent,
		'legal-document-modal-component': LegalDocumentModalComponent,
        'starken-modal-component': StarkenModalComponent
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>